<template>
    <b-card no-body>
      <!-- chart -->
      <b-card-body>
        <chartjs-component-horizontal-bar-chart
          ref="charts"
          :height="400"
          :data="localData"
          :options="chartjsDataCopy"
          v-if="loadChart"
        />
        <b-card style="height:400px" v-else>
          <div class="loading">
            <div class="effect-1 effects"></div>
            <div class="effect-2 effects"></div>
            <div class="effect-3 effects"></div>
          </div>
        </b-card>
      </b-card-body>
    </b-card>
  </template>
  <script>
  import {
    BCard, BCardBody,
    BCardHeader,
    BCardTitle
  } from 'bootstrap-vue';
  import ChartjsComponentHorizontalBarChart from '@components/charts-components/ChartjsComponentHorizontalBarChart.vue';
  import chartjsData from '@/components/charts-components/chartjsData';
  
  export default {
    components: {
      BCard,
      BCardBody,
      BCardHeader,
      BCardTitle,
  
      ChartjsComponentHorizontalBarChart,
    },
    props: {
      inf_id: {
        type: Number,
      },
      chartData: {
        type: Object,
        default: () => ({}), // Varsayılan boş obje
      },
      loadChart: {
        type: Boolean,
        default: () => true,
      },
    },
    data() {
      return {
        chartjsData,
        chartjsDataCopy: {}, // options kopyası
        localData: {}, // Grafik verisix
      };
    },
    methods: {
      updateChartOptions() {
  
        if (this.chartjsDataCopy.scales) {
          const stepBase = 50; // Yuvarlama için temel değer
          const maxTicks = 10; // Maksimum 15 değer görünsün
  
          const stepSize = Math.ceil((this.maxTickValue / maxTicks) / stepBase) * stepBase;
  
          this.chartjsDataCopy.scales.xAxes[0].ticks = {
            stepSize: stepSize,
            min: 0,
            fontColor: '#6e6b7b',
            fontSize: 11,
            callback: function (value) {
              return `${value} Adet`; // Değere "TL" ekleniyor
            },
          };
        }
        
      },
    },
    computed: {
      maxTickValue() {
        if (this.localData.datasets && this.localData.datasets[0].data.length > 0) {
          const maxDataValue = Math.max(...this.localData.datasets[0].data);
          return Math.ceil(maxDataValue * 1.5);
        }
        return 40;
      },
    },
    mounted() {
      this.chartjsDataCopy = JSON.parse(JSON.stringify(this.chartjsData.horizontalBarChart.options));
  
      const _self = this;
      this.chartjsDataCopy.tooltips.callbacks = {
        label(tooltipItem) {
          const valueArray = JSON.parse(tooltipItem.value);
          return `${valueArray} Adet`;
        }
      };
      
    },
    watch: {
      chartData: {
        handler(newData) {
          this.localData = newData;
          this.updateChartOptions();
        },
        immediate: true,
        deep: true
      },
    },
  };
  </script>
  